import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../../../utils/auth";

export default function RedirectIfAuthed() {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
